import PlayerTabProperties from "./PlayerTabProperties"
import { getAllUnsoldProperties } from "@/utils/gameHelpers"
import React, { useEffect, useRef } from "react"
import { bankOrder, images } from "@/utils/data"
import PlayerTabProperties2 from "./PlayerTabProperties2"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState } from "@/store/globalSlice"

interface BankAreaProps {
  allUnsoldProperties: ICell[]
}

const BankArea: React.FC<BankAreaProps> = ({ allUnsoldProperties }) => {
  // const elements = useAppSelector((state) => state.global.elements)
  const dispatch = useAppDispatch()
  const wrapperRef = useRef(null)
  // useEffect(() => {
  //   if (!wrapperRef.current) return
  //   if (elements.playerListItems.find((elm) => elm.order === bankOrder)) return
  //   dispatch(
  //     setState({
  //       elements: {
  //         playerListItems: [
  //           ...elements.playerListItems,
  //           { order: bankOrder, element: wrapperRef.current },
  //         ],
  //       },
  //     })
  //   )
  // }, [elements.playerListItems])
  return (
    <div
      className="flex flex-col items-center gap-4 w-full"
      style={{
        background: `url(${images.playerItemBg}) no-repeat center center`,
      }}
    >
      <div
        className="flex w-full h-32"
        id={`player-list-item-100`}
        ref={wrapperRef}
      >
        <div
          className=" text-2xl font-semibold letter tracking-widest px-8 font-poppins text-center text-white"
          style={{ writingMode: "vertical-lr" }}
        >
          BANK
        </div>
        <PlayerTabProperties2
          properties={allUnsoldProperties}
          playerOrder={bankOrder}
        ></PlayerTabProperties2>
      </div>
    </div>
  )
}

export default React.memo(BankArea)
